import { CommonColumnProps } from 'approot/activity-builder/activity-builder.constants';
import { ComponentInfoBox } from '../component.constants';
import * as Colours from 'approot/shared/styles/colours.style';
import { ZoomComponentModalProps } from 'approot/activity-builder/activity-builder-zoom-component-modal.constants';
import { InteractiveLessonSection_components_ActivitiesInfoBoxComponent_properties } from 'approot/activity-builder/__generated__/InteractiveLessonSection';
import { Settings } from 'approot/shared/richtext/richtext.constants';
import { GetActivitiesSections_getActivitiesSections_components_ActivitiesInfoBoxComponent_properties_style } from 'approot/activity-builder/__generated__/GetActivitiesSections';
import {
  COLOUR_BLUE,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_PURPLE,
  COLOUR_ORANGE,
} from 'approot/shared/colour/colour.constants';

export type ViewProps = Omit<ComponentInfoBox, '__typename'> &
  ZoomComponentModalProps;
export type EditProps = ViewProps & CommonColumnProps;
export type SettingsProps = EditProps;

export const INFO_BOX_DEFAULT_COLOUR = Colours.grey10;
export const INFO_BOX_TYPENAME = 'ActivitiesInfoBoxComponent';
export const INFO_BOX_COLOURS = [
  COLOUR_GREY,
  COLOUR_PURPLE,
  COLOUR_ORANGE,
  COLOUR_BLUE,
  COLOUR_GREEN,
];

export type InfoBoxProperties = InteractiveLessonSection_components_ActivitiesInfoBoxComponent_properties;

export const RICHTEXT_SETTINGS: Settings = {
  placeholder: 'Type here...',
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export type InfoBoxStyles = GetActivitiesSections_getActivitiesSections_components_ActivitiesInfoBoxComponent_properties_style;
